import { STOCK_CONFIG } from "../config";
import api from '../../../api/api'
import { createContext } from "react";

const StockContext = createContext({})
export const StockProvider = ({ children }) => {
    const getReservesSeedList = async (keyword, CatalogNo, setData) => {

        let _params = '';
        let _keyword = '';
        let _CatalogNo = '';

        if (keyword) {
            _keyword = 'q=' + keyword;
            _params = '?' + _keyword
        }

        if (CatalogNo) {
            _CatalogNo = 'catalogNo=' + CatalogNo;
            _params = '?' + _CatalogNo
        }
        if (keyword && CatalogNo) {
            _params = '?' + keyword + '&' + CatalogNo
        }
        const res = await api.get(STOCK_CONFIG.requests.getReserves.url + _params)
        const data = res.data
        if (data.status === true) {
            setData(data.result)
        }
    }


    const getReservesSeedAllBranchList = async (keyword, CatalogNo, setData) => {

        let _params = '';
        let _keyword = '';
        let _CatalogNo = '';

        if (keyword) {
            _keyword = 'q=' + keyword;
            _params = '?' + _keyword
        }

        if (CatalogNo) {
            _CatalogNo = 'catalogNo=' + CatalogNo;
            _params = '?' + _CatalogNo
        }
        if (keyword && CatalogNo) {
            _params = '?' + keyword + '&' + CatalogNo
        }

        const res = await api.get(STOCK_CONFIG.requests.getNonCenterReserves.url + _params)
        const data = res.data
        if (data.status === true) {
            setData(data.result)
        }
    }

    const getReservesSeedDetail = async (reserveNo, setData) => {
        const url = STOCK_CONFIG.requests.getReserves.url + `/${reserveNo}`;
        const res = await api.get(url)
        const data = res.data
        if (data.status === true) {
            setData(data.result)
        }
    }

    const getReservesByRefNo = async (refNo, setData) => {

        const url = STOCK_CONFIG.requests.getReservesByRefNo.url + `/${refNo}`;
        const res = await api.get(url)
        const data = res.data
        if (data.status === true) {
            setData(data.result)
        }
    }

    const reserveAdd = async (body, setData) => {

        if (body?.ReserveNo) {
            const url = STOCK_CONFIG.requests.getReserves.url + `/${body?.ReserveNo}`;
            const res = await api.put(url, body)
            const data = res.data
            if (data.status === true) {
                setData(data.result)
            }
        } else {
            const res = await api.post(STOCK_CONFIG.requests.getReserves.url, body)
            const data = res.data
            if (data.status === true) {
                setData(data.result)
            }
        }

    }

    const getReceivesList = async (receiveNo, branchNo, setData) => {

        let _params = ''
        let _receiveNo = ''
        let _branchNo = ''

        if (receiveNo) {
            _receiveNo = 'receiveNo=' + receiveNo;
            _params = '?' + _receiveNo
        }
        if (branchNo) {
            if (branchNo !== 'all') {
                _branchNo = 'branchNo=' + branchNo;
                _params = '?' + _branchNo
            } else {
                branchNo = '';
            }
        }
        if (receiveNo && branchNo) {
            _params = '?' + _receiveNo + '&' + _branchNo
        }

        const res = await api.get(STOCK_CONFIG.requests.getReceives.url + _params)
        const data = res.data
        if (data.status === true) {
            setData(data.result)
        }
    }

    const getReceiveDetail = async (receiveNo, setData) => {

        const url = STOCK_CONFIG.requests.getReceives.url + `/${receiveNo}`;
        const res = await api.get(url)
        const data = res.data
        if (data.status === true) {
            setData(data.result)
        }
    }

    const receiveAdd = async (body, setData) => {

        if (body?.ReceiveNo) {
            const url = STOCK_CONFIG.requests.getReceives.url + `/${body?.ReceiveNo}`;
            const res = await api.put(url, body)
            const data = res.data
            if (data.status === true) {
                setData(data.result)
            }
        } else {
            const res = await api.post(STOCK_CONFIG.requests.getReceives.url, body)
            const data = res.data
            if (data.status === true) {
                setData(data.result)
            }
        }
    }

    const getTransferList = async (transferNo, setData) => {

        let _params = '';
        let _transferNo = '';

        if (transferNo) {
            _transferNo = '?transferNo=' + transferNo;
            _params = _transferNo
        }
        const res = await api.get(STOCK_CONFIG.requests.getTransfers.url + _params)
        const data = res.data
        if (data.status === true) {
            setData(data.result)
        }
    }

    const getTransferDetail = async (transferNo, setData) => {

        const url = STOCK_CONFIG.requests.getTransfers.url + `/${transferNo}`;
        const res = await api.get(url)
        const data = res.data
        if (data.status === true) {
            setData(data.result)
        }
    }

    const getAdjustsList = async (adjustNo, branchNo, setData) => {

        let _params = '';
        let _adjustNo = ''
        let _branchNo = ''

        if (adjustNo) {
            _adjustNo = 'adjustNo=' + adjustNo;
            _params = '?' + _adjustNo
        }
        if (branchNo) {
            if (branchNo !== 'all') {
                _branchNo = 'branchNo=' + branchNo;
                _params = '?' + _branchNo
            } else {
                branchNo = '';
            }
        }
        if (adjustNo && branchNo) {
            _params = '?' + _adjustNo + '&' + _branchNo
        }
        const res = await api.get(STOCK_CONFIG.requests.getAdjusts.url + _params)
        const data = res.data
        if (data.status === true) {
            setData(data.result)
        }
    }

    const getAdjustDetail = async (adjustNo, setData) => {

        const url = STOCK_CONFIG.requests.getAdjusts.url + `/${adjustNo}`;
        const res = await api.get(url)
        const data = res.data
        if (data.status === true) {
            setData(data.result)
        }
    }

    const adjustAdd = async (body, setData) => {

        if (body?.AdjustNo) {
            const url = STOCK_CONFIG.requests.getAdjusts.url + `/${body?.AdjustNo}`;
            const res = await api.put(url, body)
            const data = res.data
            if (data.status === true) {
                setData(data.result)
            }
        } else {
            const res = await api.post(STOCK_CONFIG.requests.getAdjusts.url, body)
            const data = res.data
            if (data.status === true) {
                setData(data.result)
            }
        }

    }

    const transferAdd = async (body, setData) => {

        if (body?.TransferNo) {
            const url = STOCK_CONFIG.requests.getTransfers.url + `/${body?.TransferNo}`;
            const res = await api.put(url, body)
            const data = res.data
            if (data.status === true) {
                setData(data.result)
            }
        } else {
            const res = await api.post(STOCK_CONFIG.requests.getTransfers.url, body)
            const data = res.data
            if (data.status === true) {
                setData(data.result)
            }
        }
    }

    const getReservesCenterList = async (keyword, CatalogNo, setData) => {

        let _params = '';
        let _keyword = '';
        let _CatalogNo = '';

        if (keyword) {
            _keyword = '?q=' + keyword;
        }

        if (CatalogNo) {
            _CatalogNo = '?catalogNo=' + CatalogNo;
        }
        _params = _keyword + _CatalogNo

        const res = await api.get(STOCK_CONFIG.requests.getReservesCenter.url + _params)
        const data = res.data
        if (data.status === true) {
            setData(data.result)
        }
    }

    const getLots = async (BranchNo, keyword, lotNumber, sumLots, setData) => {

        let _params = '';
        let _name = '';
        let _lot = '';
        let _sumLots = '';

        if (keyword) {
            _name = '?name=' + keyword;
        }
        if (lotNumber) {
            _lot = '?lot=' + lotNumber;
        }
        if (sumLots) {
            _sumLots = '?sumLots=' + sumLots;
        }

        _params = _name + _lot + _sumLots
        const url = STOCK_CONFIG.requests.getLotsBranch.url + `/${BranchNo}/lots`;
        const res = await api.get(url + _params)
        const data = res.data
        if (data.status === true) {
            setData(data.result)
        }
    }

    const getAllBranchLots = async (keyword, lot, setData) => {

        let _params = '';
        let _name = '';
        let _lot = '';

        if (keyword) {
            _name = '?name=' + keyword;
        }
        if (lot) {
            _lot = '?lot=' + lot;
        }

        const url = STOCK_CONFIG.requests.getAllBranchLot.url;
        const res = await api.get(url + _params)
        const data = res.data
        if (data.status === true) {
            setData(data.result)
        }
    }
    const getAllLots = async (ItemNo, setData) => {

        let _params = '';
        let _ItemNo = '';

        if (ItemNo) {
            _ItemNo = '?ItemNo' + ItemNo;
        }
        _params = _ItemNo

        const url = STOCK_CONFIG.requests.getAllLot.url + `/${ItemNo}/all-lots`;;
        const res = await api.get(url, { params: _params })
        const data = res.data
        if (data.status === true) {
            setData(data.result)
        }
    }
    const getZones = async (BranchNo, setData) => {

        const url = STOCK_CONFIG.requests.getZonesBranch.url + `/${BranchNo}/zones`;
        const res = await api.get(url)
        const data = res.data
        if (data.status === true) {
            setData(data.result)
        }
    }
    const getAllLotHQ = async (keyword, lotNumber, sumLots, setData) => {


        let _params = '';
        let _name = ''
        let _lot = ''
        let _sumLots = ''

        if (keyword) {
            _name = 'name=' + keyword;
            _params = '?' + _name
        }
        if (sumLots) {
            _sumLots = 'sumLots=' + sumLots;
            _params = '?' + _sumLots
        }
        if (lotNumber) {
            if (lotNumber !== 'all') {
                _lot = 'lot=' + lotNumber;
                _params = '?' + _lot
            } else {
                lotNumber = '';
            }
        }
        if (keyword && sumLots && lotNumber) {
            _params = '?' + _name + '&' + _lot + '&' + _sumLots
        }
        const res = await api.get(STOCK_CONFIG.requests.getAllLotHq.url + _params)
        const data = res.data
        if (data.status === true) {
            setData(data.result)
        }
    }
    async function getImportReserves(formData) {
        const res = await api.post(STOCK_CONFIG.requests.importReserves.url, formData)
        const data = res.data
        if (data.status === true) {
            return data.result
        }
    }

    

    const contextData = {
        getReservesSeedList: getReservesSeedList,
        getReservesSeedAllBranchList: getReservesSeedAllBranchList,
        getReservesSeedDetail: getReservesSeedDetail,
        getReservesByRefNo: getReservesByRefNo,
        reserveAdd: reserveAdd,
        getReceivesList: getReceivesList,
        getReceiveDetail: getReceiveDetail,
        receiveAdd: receiveAdd,
        getTransferList: getTransferList,
        getTransferDetail: getTransferDetail,
        getAdjustsList: getAdjustsList,
        getAdjustDetail: getAdjustDetail,
        adjustAdd: adjustAdd,
        transferAdd: transferAdd,
        getReservesCenterList: getReservesCenterList,
        getLots: getLots,
        getAllBranchLots: getAllBranchLots,
        getAllLots, getAllLots,
        getZones: getZones,
        getAllLotHQ: getAllLotHQ,
        getImportReserves: getImportReserves,
    }
    return (
        <StockContext.Provider value={contextData}>
            {children}
        </StockContext.Provider>
    )
}

export default StockContext





//     async getNotify() {

//     let _params = new HttpParams();

//     const res = await this.http.get < ResponseAPI > (STOCK_CONFIG.requests.getNotify.url, { params: _params }).toPromise();
//     return res;
// }



//     async downloadReceive(receiveNo: string) {
//     let _params = new HttpParams();


//     const url = STOCK_CONFIG.requests.getReceives.url + `/${receiveNo}/pdf`;
//     const res: any = await this.http.get(url, {
//         params: _params,
//         responseType: 'arraybuffer'
//     }).toPromise();
//     return res;
// }

//     async downloadReserve(reserveNo: string) {
//     let _params = new HttpParams();


//     const url = STOCK_CONFIG.requests.getReserves.url + `/${reserveNo}/pdf`;
//     const res: any = await this.http.get(url, {
//         params: _params,
//         responseType: 'arraybuffer'
//     }).toPromise();
//     return res;
// }

//     async downloadTransfer(transferNo: string) {
//     let _params = new HttpParams();


//     const url = STOCK_CONFIG.requests.getTransfers.url + `/${transferNo}/pdf`;
//     const res: any = await this.http.get(url, {
//         params: _params,
//         responseType: 'arraybuffer'
//     }).toPromise();
//     return res;
// }

//     async downloadAdjust(adjustNo: string) {
//     let _params = new HttpParams();


//     const url = STOCK_CONFIG.requests.getAdjusts.url + `/${adjustNo}/pdf`;
//     const res: any = await this.http.get(url, {
//         params: _params,
//         responseType: 'arraybuffer'
//     }).toPromise();
//     return res;
// }

